<div class="overflow-x-auto rounded-lg border border-gray-200 dark:border-gray-800" appGrillaNav [tabSiguienteFila]="true"
  (pegarColumna)="pegar($event)">
  <table class="min-w-full text-sm">
    <thead class="bg-gray-50 dark:bg-gray-800">
      <tr class="text-left text-xs font-semibold uppercase text-gray-600 dark:text-gray-300">
        <th class="w-10 px-2 py-2">N°</th>
        <th class="min-w-48 px-2 py-2">Nombre</th>
        <th class="w-56 px-2 py-2">Objetivo</th>
        <th class="w-56 px-2 py-2">
          <span class="inline-flex items-center gap-1">
            Zona
            @if (puedeCrearZona) {
              <app-icon-button icon="add" [ariaLabel]="'Nueva zona'" [tooltip]="'Nueva zona'" [disabled]="deshabilitada"
                (onClick)="crearZona()" />
            }
          </span>
        </th>
        <th class="w-24 px-2 py-2">Km</th>
        <th class="min-w-48 px-2 py-2">Dirección</th>
        <th class="w-10"></th>
      </tr>
    </thead>
    <tbody>
      @for (fila of filas; track fila.uid; let i = $index) {
        @let error = mensaje(fila);
        <tr class="border-t border-gray-100 dark:border-gray-800" [class.bg-error-50]="error" (focusin)="onFoco(i)">
          <td class="px-2 py-1 text-gray-400">{{ i + 1 }}</td>
          <td class="px-1 py-1">
            <input type="text" class="celda w-full" data-col="nombre" [attr.data-fila]="i" aria-label="Nombre"
              [value]="fila.nombre" [disabled]="deshabilitada" (input)="onCambio(fila, 'nombre', $event)" />
          </td>
          <td class="px-1 py-1">
            <select class="celda w-full" data-col="objetivo" [attr.data-fila]="i" aria-label="Objetivo"
              [value]="fila.objetivo" [disabled]="deshabilitada" (change)="onCambio(fila, 'objetivo', $event)">
              <option value=""></option>
              @for (o of objetivos; track o.value) {
                <option [value]="o.value" [selected]="fila.objetivo === o.value">{{ o.label }}</option>
              }
            </select>
          </td>
          <td class="px-1 py-1">
            <select class="celda w-full" data-col="ubi_zona_id" [attr.data-fila]="i" aria-label="Zona"
              [value]="fila.ubi_zona_id" [disabled]="deshabilitada" (change)="onCambio(fila, 'ubi_zona_id', $event)">
              <option value=""></option>
              @for (z of zonas; track z.id) {
                <option [value]="z.id" [selected]="fila.ubi_zona_id === '' + z.id">{{ z.nombre }}</option>
              }
            </select>
          </td>
          <td class="px-1 py-1">
            <input type="number" min="0" step="0.1" class="celda w-full text-right" data-col="km" [attr.data-fila]="i"
              aria-label="Kilómetro" [value]="fila.km" [disabled]="deshabilitada" (input)="onCambio(fila, 'km', $event)" />
          </td>
          <td class="px-1 py-1">
            <input type="text" class="celda w-full" data-col="direccion" [attr.data-fila]="i" aria-label="Dirección"
              [value]="fila.direccion" [disabled]="deshabilitada" (input)="onCambio(fila, 'direccion', $event)" />
          </td>
          <td class="px-1 py-1 text-center">
            @if (tieneDatos(fila) && !deshabilitada) {
              <button type="button" class="text-gray-400 hover:text-error-500" [attr.aria-label]="'Quitar fila ' + (i + 1)"
                (click)="quitar(fila)">✕</button>
            }
          </td>
        </tr>
        @if (error) {
          <tr class="bg-error-50 dark:bg-error-500/10">
            <td></td>
            <td colspan="6" class="px-2 pb-2 text-xs text-error-500">{{ error }}</td>
          </tr>
        }
      }
    </tbody>
  </table>
</div>
